import { inject, Injectable, Renderer2 } from '@angular/core';
import { EInputMesStatusType, EUploadPicPanelType } from '@type/enums/mobile';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class MobileSideService {

  private commonServe = inject(CommonService)

  public renderer!: Renderer2
  // 当前用户语音权限状态
  public voiceAuthorityStatus: boolean = true
  // 消息列表显示状态
  public disListVisible: boolean = false
  // 上传图片界面显示状态
  public uploadPicStatus: EUploadPicPanelType = EUploadPicPanelType.ADD
  // 聊天页面白色蒙板（修改状态呈现）
  public hasMask: boolean = false
  // 修改最后一条信息/输入新的信息状态
  public isModifyOrNewMes: EInputMesStatusType = EInputMesStatusType.NEW

  // 用户发送消息值
  public sendMesText: string = ''
  // 修改文本内容
  public modifyInput: string = ''

  // IOS键盘聚焦与失焦时，页面适配
  public IOSKeyboardAdaption() {
    // 文本框聚焦，键盘弹出
    this.renderer.listen(document.body, 'focusin', () => {
      this._keyboardPopUp()
      this.setFullHeight()
    })

    // 文本框失焦，键盘收回
    this.renderer.listen(document.body, 'focusout', () => {
      this._keyboardReback()
    })
  }

  // Android键盘聚焦与失焦时，页面适配
  public AndroidKeyboardAdaption() {
    const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
    this.renderer.listen(window, 'resize', () => {
      const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
      resizeHeight < originalHeight ? this._keyboardPopUp() : this._keyboardReback()
    })
  }

  // 设置页面高度
  public setFullHeight() {
    const viewportHeight = `${window.innerHeight}px`
    const diaContainer = document.getElementById('dia-container')
    diaContainer && this.renderer.setStyle(diaContainer, 'height', viewportHeight)
  }

  // 键盘弹出
  private _keyboardPopUp() {
    // 对话整体界面
    const diaContainer = document.getElementById('dia-container')
    // 输入
    const inputContainer = document.getElementById('dia-input-container')
    // 聊天内容
    const diaConContainer = document.getElementById('chat-main')
    // 界面头部
    const diaHeaderContainer = document.getElementById('dia-header-container')

    // 隐藏滚动底部按钮
    this.commonServe.toBottomBtnStatus = false

    setTimeout(() => {
      // 计算整体界面高度，并调整至合适位置
      diaContainer && this.renderer.setStyle(diaContainer, 'height', `${window.visualViewport?.height || window.innerHeight}px`)
      window.scrollTo(0, 0)

      // 整体页面滚动事件调整
      this.renderer.listen(document.body, 'touchend', () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      })
    }, 250)

    // 计算聊天内容显示区域的高度并将内容滚动至底部
    if (diaConContainer) {
      setTimeout(() => {
        if (inputContainer && diaHeaderContainer) {
          this.renderer.setStyle(diaConContainer, 'height',
            `${(window.visualViewport?.height || window.innerHeight) - inputContainer.clientHeight - diaHeaderContainer.clientHeight}px`)
          this.renderer.setProperty(diaConContainer, 'scrollTop', diaConContainer.scrollHeight)
        }
      }, 250)

      // 点击屏幕让键盘收回
      diaConContainer.addEventListener('touchstart', () => { this._keyboardReback() })
    }
  }

  // 键盘回退
  private _keyboardReback() {
    (document.getElementById('input-text') || document.getElementById('update-input'))?.blur()
    setTimeout(() => { this.setFullHeight() }, 50)
  }

}
